<template>
    <div class="px-6 pb-1 pt-4">
        <vs-button @click="editPopup = true" class="w-full">{{$t('mass_change')}}</vs-button>

        <vs-popup class="edit_popup" :title="$t('mass_change')" :active.sync="editPopup">
            <vs-alert class="h-auto" active="true">
                {{$t('journal_mass_message')}}
            </vs-alert>

            <div>
                <div>
                    <div class="mb-2 mt-4"  >
                        <strong class="mb-3 block">{{$t('status')}}</strong>
                        <div class="flex">
                            <div class="mb-2 lg:mb-0 lg:mr-4">
                                <vs-radio
                                    v-model="status"
                                    color="success"
                                    :vs-value="true">
                                    {{$t('open2')}}
                                </vs-radio>
                            </div>
                            <div>
                                <vs-radio
                                    v-model="status"
                                    color="danger"
                                    :vs-value="false">
                                    {{$t('close')}}
                                </vs-radio>
                            </div>
                        </div>
                    </div>

                    <!-- Попап с выбором даты -->
                    <vs-row v-if="status">
                        <vs-col>
                            <span>{{ $t('date_start') }}:</span>
                            <flat-pickr
                                v-if="status"
                                v-model="data_start"
                                :config="config"/>
                        </vs-col>
<!--                        <vs-divider></vs-divider>-->
                        <vs-col>
                            <span>{{ $t('date_end') }}:</span>
                            <flat-pickr
                                v-if="status"
                                v-model="data_end"
                                :config="config"/>
                        </vs-col>

                    </vs-row>
                    <vs-row v-else>
                        <span>{{ $t('scheduled_blocking') }}:</span>
                        <flat-pickr
                            v-model="date_time"
                            :config="config0"/>
                    </vs-row>


                    <div class="mt-3">
                        <vs-button
                            @click="formClear()"
                            type="border"
                            color="dark"
                            class="w-full mb-2">
                            {{$t('clear')}}
                        </vs-button>
                        <vs-button
                            icon-pack="feather"
                            @click="formSubmit()"
                            icon="icon-save"
                            class="w-full mass_save_btn">
                            {{$t('save')}}
                        </vs-button>
                    </div>
                </div>
<!--                <div v-else>-->
<!--                    <div class="mb-2 mt-4"  >-->
<!--                        <strong class="mb-3 block">{{$t('status')}}</strong>-->
<!--                        <div class="flex">-->
<!--                            <div class="mb-2 lg:mb-0 lg:mr-4">-->
<!--                                <vs-radio-->
<!--                                    v-model="status"-->
<!--                                    color="success"-->
<!--                                    :vs-value="true">-->
<!--                                    {{$t('open2')}}-->
<!--                                </vs-radio>-->
<!--                            </div>-->
<!--                            <div>-->
<!--                                <vs-radio-->
<!--                                    v-model="status"-->
<!--                                    color="danger"-->
<!--                                    :vs-value="false">-->
<!--                                    {{$t('close')}}-->
<!--                                </vs-radio>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <vs-row v-if="!status">-->
<!--                        <span>{{ $t('scheduled_blocking') }}:</span>-->
<!--                        <flat-pickr-->
<!--                            v-model="date_time"-->
<!--                            :config="config0"/>-->
<!--                    </vs-row>-->


<!--                    <div class="mt-3">-->
<!--                        <vs-button-->
<!--                            @click="formClear()"-->
<!--                            type="border"-->
<!--                            color="dark"-->
<!--                            class="w-full mb-2">-->
<!--                            {{$t('clear')}}-->
<!--                        </vs-button>-->
<!--                        <vs-button-->
<!--                            icon-pack="feather"-->
<!--                            @click="formSubmit()"-->
<!--                            icon="icon-save"-->
<!--                            class="w-full mass_save_btn">-->
<!--                            {{$t('save')}}-->
<!--                        </vs-button>-->
<!--                    </div>-->
<!--                </div>-->
            </div>

        </vs-popup>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Russian } from 'flatpickr/dist/l10n/ru'
import { Kazakh } from 'flatpickr/dist/l10n/kz'
import {mapGetters} from "vuex";

const datePicker = {
    time_24hr: true,
    enableTime: true,
    altFormat: 'd.m.Y H:i',
    dateFormat: 'Y-m-dTH:i:S+06:00',
}
const datePicker0= {
    minDate: new Date().setMinutes( new Date().getMinutes() + 5 ),
    time_24hr: true,
    enableTime: true,
    altFormat: 'd.m.Y H:i',
    dateFormat: 'Y-m-dTH:i:S+06:00',
}

export default {
    props: {
        itemHandler: {
            type: Function,
            default: () => {}
        },
        getBlocksNone:{

        }
    },
    data() {
        return {
            config: {
                ...datePicker,
                inline: true,
                // locale: this.$i18n.locale === 'kk' ? 'kz' : this.$i18n.locale
            },
            editPopup: false,
            date_time: null,
            status: true,
            data_start:null,
            data_end:null,
            config0: {
                ...datePicker0,
                inline: true,
                // locale: this.$i18n.locale === 'kk' ? 'kz' : this.$i18n.locale
            },
        }
    },
    methods: {
        formClear() {
            this.date_time = null
            this.status = true
            this.data_start = null
            this.data_end = null
        },
        async formSubmit() {
            // if(this.getBlocksNone){
            if(this.status){
                if(this.data_start == null || this.data_end == null) {
                    this.$vs.notify({
                        text: this.$t('fill_date_start_and_date_end'),
                        color: 'danger'
                    })

                } else if(this.data_start > this.data_end){

                    this.$vs.notify({
                        text: this.$t('date_start_must_be_smaller_than_date_end'),
                        color: 'danger'
                    })

                }else{
                    try {
                        this.$vs.loading({
                            container: ".mass_save_btn",
                            scale: 0.45
                        })

                        const query = this.$route.query

                        let queryData = {
                            status: this.status ? 1 : 0,
                            data_start: this.data_start,
                            data_end: this.data_end
                        }

                        if(Object.keys(query).length) {
                            for (let key in query) {
                                if(key !== 'status')
                                    queryData[key] = query[key]
                            }
                        }
                        await this.$http.post("/admin/journal_change_status/masschangestatus/", {getBlocksNone:this.getBlocksNone,queryData:queryData,...this.$route.query})
                    } catch(e) {
                        this.$vs.notify({
                            text: this.$t('error'),
                            color: 'danger'
                        })
                    } finally {
                        this.$vs.loading.close(".mass_save_btn > .con-vs-loading")

                        this.data_start = null
                        this.data_end = null
                        this.status = true
                        this.editPopup = false

                        // Чистим текущий список
                        this.$store.commit('block_journal/CLEAR_JOURNAL_LIST')

                        // Обновляем список журналов
                        this.itemHandler({update: true})
                    }
                }

            }else{
                try {
                    this.$vs.loading({
                        container: ".mass_save_btn",
                        scale: 0.45
                    })

                    const query = this.$route.query

                    let queryData = {
                        status: this.status ? 1 : 0,
                        date_time: this.date_time
                    }

                    if(Object.keys(query).length) {
                        for (let key in query) {
                            if(key !== 'status')
                                queryData[key] = query[key]
                        }
                    }
                    await this.$http.post("/admin/journal_change_status/masschangestatus/", {getBlocksNone:this.getBlocksNone,queryData:queryData,...this.$route.query})
                } catch(e) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                } finally {
                    this.$vs.loading.close(".mass_save_btn > .con-vs-loading")

                    this.data_start = null
                    this.data_end = null
                    this.status = true
                    this.editPopup = false

                    // Чистим текущий список
                    this.$store.commit('block_journal/CLEAR_JOURNAL_LIST')

                    // Обновляем список журналов
                    this.itemHandler({update: true})
                }
            }

            // }

        }
    },
    watch: {
        windowWidth () {
            this.setSidebarWidth()
        }
    },
    computed: {
        selectedDate() {
            if(this.date_time)
                return this.$moment(this.date_time).format('DD.MM.YYYY H:mm')
            else
                return this.$t('select_date_and_time')
        },
        windowWidth() { return this.$store.state.windowWidth },
        ...mapGetters({
            getBlocks:'system_settings/getBlocks',
            start_date_end_date:'block_journal/start_date_end_date',
        }),
    }
}
</script>

<style lang="scss">
.edit_popup{
    .mass_save_btn{
        position: relative;
        .con-vs-loading{
            position: absolute;
        }
    }
    .vs-popup{
        width: 370px;
    }
    .flatpickr-input{
        display: none;
    }
    .flatpickr-calendar{
        box-shadow: initial!important;
    }
}
</style>
